(function() {

	var transitionTime = 400;

	var touchPoint;

	function offCanvasOn(side, noPushState) {
		if (!side) side = "left";
		window.setTimeout(endTransitionOn, transitionTime+1);
		startTransitionOn(side);
		if (history.pushState && !noPushState && location.hash != "#body-"+side) {
			history.pushState(null, null, "#body-"+side);
		}
	}

	function offCanvasOff(noPushState) {
		window.setTimeout(endTransitionOff, transitionTime+1);
		startTransitionOff();		
		if (history.pushState && !noPushState && location.hash != "#body-main" && location.hash != "") {
			history.pushState(null, null, "#body-main");
		}		
	}

	function offCanvasToggle(side) {
		if (!side) side = "left";
		if ($(document.body).is('.showing-offcanvas-'+side)) {
			offCanvasOff();
		} else {
			offCanvasOn(side);
		}
	}

	window.addEventListener("popstate", function(e) {
		switch (location.hash) {
			case "#body-left":
				offCanvasOn("left", true);
				break;

			case "#body-right":
				offCanvasOn("right", true);
				break;

			case "#body-main":
			case "":
				offCanvasOff(true);
				break;
		}
	});	



	function startTransitionOn(side) {
		$("#navbar").css("top", $(window).scrollTop());
		$(".offcanvas-frame").addClass("transitioning");
		$(document.body).addClass('showing-offcanvas-'+side+' showing-offcanvas transitioning');		
	}

	function endTransitionOn() {
		$("#navbar").css("top", $(window).scrollTop());
		$(".offcanvas-frame").removeClass("transitioning");
		$(document.body).removeClass("transitioning");

		// Prevents scrolling on remainder of main body
		$("#body-main").on("touchmove.offcanvas", function (e) {
			e.preventDefault();
		})

		// Touch to return
		.on("click.offcanvas", function (e) {
			offCanvasOff();
		})


		// When we start touching, start dragging spring
		// Swipe to return
		.on("touchstart.offcanvas", function (e) {
			touchPoint = {"x": e.originalEvent.pageX, "y": e.originalEvent.pageY}

		})
		.on("touchmove.offcanvas", function (e) {
			var point = {"x": e.originalEvent.pageX, "y": e.originalEvent.pageY};
			var deltaX = (touchPoint.x - point.x);
			var deltaY = (touchPoint.y - point.y);
			if (deltaY / deltaX > 0.2) { // Too diagonal
				return;
			}	
			var $body = $(document.body);
			var size = Math.abs(deltaX);


			if ($body.is(".showing-offcanvas-left")) {
				if (deltaX > 0 && size > 40) {
					if (!$body.is(".pulling-spring")) {
						$body.addClass("pulling-spring transitioning");
					}
				} else if (deltaX < 0 || size < 40) {
					if ($body.is(".pulling-spring")) {
						$body.removeClass("pulling-spring transitioning");
					}					
				}
			} else if ($body.is(".showing-offcanvas-right")) {
				if (deltaX < 0 && size > 40) {
					if (!$body.is(".pulling-spring")) {
						$body.addClass("pulling-spring transitioning");
					}
				} else if (deltaX > 0 || size < 40) {
					if ($body.is(".pulling-spring")) {
						$body.removeClass("pulling-spring transitioning");
					}					
				}
			}
		})
		.on("touchend.offcanvas", function(e) {
			var point = {"x": e.originalEvent.pageX, "y": e.originalEvent.pageY};
			$(document.body).removeClass("pulling-spring");			
			var deltaX = (touchPoint.x - point.x);
			var deltaY = (touchPoint.y - point.y);

			if (deltaY / deltaX > 0.2) { // Too diagonal
				return;
			}

			if (Math.abs(deltaX) < $(window).width() * 0.15) { // Too small swipe
				return;
			}

			if ($(document.body).is(".showing-offcanvas-left") && deltaX > 0) {
				offCanvasOff();
				return;
			}
			if ($(document.body).is(".showing-offcanvas-right") && deltaX < 0) {
				offCanvasOff();
				return;
			}


		});

		// Fix for iOS Safari with sticky footer
		/*
		$("#contacts-pane").find(".social-links.sticky").css({
			"width": "100%",
			"left": "14%"
		});
		window.setTimeout(function() {
			$("#contacts-pane").find(".social-links.sticky").css({
				"width": "85%",
				"left": "15%"
			});
		},200);
		*/

	}

	function startTransitionOff() {
		$(".offcanvas-frame").addClass("transitioning");
		$(document.body).addClass("transitioning").removeClass('showing-offcanvas-left showing-offcanvas-right showing-offcanvas pulling-spring');		
		$("#body-main").off(".offcanvas");		

	}

	function endTransitionOff() {
		$("#navbar").css("top", "");
		$(".offcanvas-frame").removeClass("transitioning");
		$(document.body).removeClass("transitioning");
	}



	window.offcanvas.offCanvasOn = offCanvasOn;
	window.offcanvas.offCanvasOff = offCanvasOff;
	window.offcanvas.offCanvasToggle = offCanvasToggle;

})();

$(function() {
	$("#body-left").swipe({
		"swipeLeft": offcanvas.offCanvasOff
	});
	$("#body-right").swipe({
		"swipeRight": offcanvas.offCanvasOff
	});
	$("#return-icons .return-icon").on("click", function() {
		offcanvas.offCanvasOff();
		return false;
	});
	$(".return-arrow").on("click", function() {
		offcanvas.offCanvasOff();
		return false;
	});


});